<div edsGrid *ngIf="loadChart">
  <div edsRow>
    <div edsCol>
      <div edsSpacing="md"></div>

      <eds-proximal placement="LiquidAssetsProximalPlacementTop"></eds-proximal>

      <eds-section-header
        [title]="'products.price-liquid-assets-section-title' | translate"
        [level]="6"
        [asOfLabel]="'products.as-of' | translate"
        [asOfDate]="chartAsOfDate"
        edsSpacing="md"
        caveatPlacement="Liquid Assets:6MonthLiquidAssets"
      ></eds-section-header>
    </div>
  </div>

  <div edsRow>
    <div edsCol>
      <highcharts-chart
        *ngIf="highcharts"
        [Highcharts]="highcharts"
        [options]="chartOptions"
        style="width: 100%; height: 400px; display: block"
      ></highcharts-chart>

      <eds-proximal
        placement="LiquidAssetsProximalPlacementBottom"
      ></eds-proximal>
    </div>
  </div>
</div>
